/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, February 9th 2022, 1:11:46 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { UseDragDropListItemArgs, useDragDropListItem } from "ui-widgets/drag-and-drop/dnd-list/useDragDropListItem";
import { useSpring, animated } from "@react-spring/web";
import { ObjectValue } from "lib/types";

interface DragDropListItemWrapperProps<T> extends UseDragDropListItemArgs<T> {
  children: React.ReactNode;
  draggedItemStyle?: React.CSSProperties;
  dragHoveredItemStyle?: React.CSSProperties;
}

interface AnimatedDragDropListItemWrapperProps<T> extends DragDropListItemWrapperProps<T> {
  firstItemPosition: ObjectValue<T> & number;
}

// const draggedItemStyle: React.CSSProperties = { opacity: 0 };

// const draggedItemBorderStyle: React.CSSProperties = { border: "1px dotted" };
// const draggedItemBorderStyle: React.CSSProperties = {};

// const dragHoveredItemStyle: React.CSSProperties = {
//   // background: COLORSCHEME.secondaryVariant,
//   // transition: "background 0.5s",
// };

export const AnimatedDragDropListItemWrapper = <T,>({
  firstItemPosition,
  ...props
}: AnimatedDragDropListItemWrapperProps<T>) => {
  const repositioningFactor = props.currentItemPosition - firstItemPosition;

  const animatedStlye = useSpring({ transform: `translateY(${repositioningFactor * 100}%)` });

  return (
    <animated.div
      style={{
        position: "absolute",
        width: "100%",
        ...animatedStlye,
      }}
    >
      <DragDropListItemWrapper {...props} />
    </animated.div>
  );
};

export const DragDropListItemWrapper = <T,>({
  children,
  currentItemId,
  currentItemPosition,
  handleDragEnter,
  handleDrop,
  itemType,
  draggedItemStyle,
  dragHoveredItemStyle,
  isDraggableItem,
}: DragDropListItemWrapperProps<T>) => {
  const { itemIsBeingDragged, itemIsBeingDraggedOver, dndListItemElRef } = useDragDropListItem<T>({
    currentItemId,
    currentItemPosition,
    handleDragEnter,
    handleDrop,
    itemType,
    isDraggableItem,
  });

  const dndItemStyle = itemIsBeingDragged
    ? { ...draggedItemStyle, opacity: 0 }
    : itemIsBeingDraggedOver
    ? dragHoveredItemStyle
    : null;

  return (
    <div ref={dndListItemElRef} style={dndItemStyle}>
      {children}
    </div>
  );
};
